import { tablesQueryKeys } from '@features/tables/api/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { getTables } from '../api/tables.api'

export function useTables() {
  return useQuery({
    queryKey: tablesQueryKeys.tables,
    queryFn: getTables,
    staleTime: 1000 * 60 * 5,
  })
}
